import { render, staticRenderFns } from "./business-detail.vue?vue&type=template&id=55662782&scoped=true&"
import script from "./business-detail.vue?vue&type=script&lang=js&"
export * from "./business-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55662782",
  null
  
)

export default component.exports